export default __webpack_public_path__ + "static/media/solutions-for-a-sustainable-future.722ce933.jpg";